import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import ProfileAutoSub from 'routes/Profile/ProfileScreen/tabs/InfoTab/components/ProfileAutoSub'
import MyTeamAutoSub from 'routes/Game/components/MyTeamTab/components/MyTeamAutoSub'
import SelectStakeAutoSub from
  'routes/SelectStake/SelectStakeScreen/components/SelectStakeAutoSub'

import { Divider } from '@material-ui/core'

import { AutoSubProvider } from 'contexts/AutoSub'
import { GeneralResponse } from 'protos'

const fakeData = {
  ackAutosubIntro: () => {
    action('ackAutosubIntro')()
    return Promise.resolve(GeneralResponse.fromObject({ result: GeneralResponse.Result.GR_SUCCESS }))
  },
  onStoreClick: action('onStoreClick'),
}

storiesOf('AutoSub', module)
  .add('ProfileAutoSub', () => (
    <div>
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: false, remainingSubs: 0 }}>
        <ProfileAutoSub />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 0 }}>
        <ProfileAutoSub />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 5 }}>
        <ProfileAutoSub />
      </AutoSubProvider>
    </div>
  ))
  .add('MyTeamAutoSub', () => (
    <div>
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: false, remainingSubs: 0 }}>
        <MyTeamAutoSub onUse={action('onUse')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 0 }}>
        <MyTeamAutoSub onUse={action('onUse')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 5 }}>
        <MyTeamAutoSub onUse={action('onUse')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 5 }}>
        <MyTeamAutoSub isLoading onUse={action('onUse')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 5 }}>
        <MyTeamAutoSub isActivated onUse={action('onUse')} />
      </AutoSubProvider>
    </div>
  ))
  .add('SelectStakeAutoSub', () => (
    <div>
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: false, remainingSubs: 0 }}>
        <SelectStakeAutoSub onToggle={action('onToggle')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 0 }}>
        <SelectStakeAutoSub onToggle={action('onToggle')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 5 }}>
        <SelectStakeAutoSub onToggle={action('onToggle')} />
      </AutoSubProvider>
      <Divider />
      <AutoSubProvider value={{ ...fakeData, isAcknowledged: true, remainingSubs: 5 }}>
        <SelectStakeAutoSub isActivated onToggle={action('onToggle')} />
      </AutoSubProvider>
    </div>
  ))
